import React from 'react';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { DirectBudgetRollupRow } from './types';
import { formatMoney, formatNumber } from './format';

type Props = { rows: DirectBudgetRollupRow[] };

const DirectBudgetRollupPanel: React.FC<Props> = ({ rows }) => (
  <Paper elevation={1} sx={{ p: 2 }}>
    <Typography variant="h6" sx={{ mb: 2 }}>Direct Budget Rollup</Typography>
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Cost Center</TableCell>
          <TableCell>Account</TableCell>
          <TableCell align="right">Lines</TableCell>
          <TableCell align="right">Requested</TableCell>
          <TableCell align="right">Approved</TableCell>
          <TableCell align="right">Amount</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, idx) => (
          <TableRow key={`${row.ccc}-${row.acc}-${idx}`} hover>
            <TableCell>{row.ccc} {row.ccn}</TableCell>
            <TableCell>{row.acc} {row.acn}</TableCell>
            <TableCell align="right">{formatNumber(row.linecount)}</TableCell>
            <TableCell align="right">{formatMoney(row.requestedamount)}</TableCell>
            <TableCell align="right">{formatMoney(row.approvedamount)}</TableCell>
            <TableCell align="right">{formatMoney(row.amount)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Paper>
);

export default DirectBudgetRollupPanel;
